import React from 'react'

export default function CompletedOrders() {
  return (
    <div>CompletedOrders</div>
  )
}
